import { ButtonProps, Modal as AntdModal, ModalProps } from 'antd';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from '../../icons/close-icon';
import CustomButton from '../buttons/custom-button/custom-button';
import IconWrapper from '../icon-wrapper/icon-wrapper';
import styles from './modal.module.css';

interface Props {
  formId?: string;
  title: ReactNode;
  isOpen: boolean;
  isLoading?: boolean;
  customSubmitText?: string;
  customDeleteText?: string;
  children: ReactNode;
  afterClose: ModalProps['afterClose'];
  modalProps?: ModalProps;
  submitButtonProps?: ButtonProps;
  onOk?: () => void;
  onCancel: () => void;
  width?: number;
  isClosable?: boolean;
  disableSubmitBtn?: boolean;
}

const Modal = ({
  children,
  title,
  isOpen,
  onOk,
  onCancel,
  isLoading,
  afterClose,
  modalProps,
  submitButtonProps,
  customSubmitText,
  customDeleteText,
  formId,
  width = 576,
  isClosable,
  disableSubmitBtn = false,
}: Props): JSX.Element => {
  const { t } = useTranslation('common');

  return (
    <AntdModal
      className={clsx(styles.antdModal, 'antd-modal')}
      title={title}
      open={isOpen}
      onOk={onOk}
      onCancel={onCancel}
      maskClosable={false}
      centered
      closable={isClosable && !isLoading}
      closeIcon={
        <IconWrapper>
          <CloseIcon />
        </IconWrapper>
      }
      width={width}
      afterClose={afterClose}
      footer={[
        isClosable && (
          <CustomButton data-testid="closeButtonId" type="secondary" key="back" onClick={onCancel} disabled={isLoading}>
            {customDeleteText || t('action.cancel')}
          </CustomButton>
        ),
        <CustomButton
          data-testid="saveButtonId"
          key="submit"
          onClick={onOk}
          loading={isLoading}
          type="primary"
          form={formId}
          disabled={isLoading || disableSubmitBtn}
          htmlType="submit"
          {...submitButtonProps}
        >
          {customSubmitText || t('action.save')}
        </CustomButton>,
      ]}
      {...modalProps}
    >
      <div className={styles.modalContent}>{children}</div>
    </AntdModal>
  );
};

export default Modal;
